import React from "react";
import { SiteConfigsProvider } from "./src/context/SiteConfigsContext";

export const wrapRootElement = ({ element }) => (
 <SiteConfigsProvider>{element}</SiteConfigsProvider>
);
